require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./challenging-background-norms.json") })
        }
      }, "path---challenging-background-norms");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---challenging-background-norms!./.cache/json/challenging-background-norms.json
// module id = 504
// module chunks = 231608221292675